import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=567b100b&scoped=true"
import script from "./exchange.vue?vue&type=script&lang=js"
export * from "./exchange.vue?vue&type=script&lang=js"
import style0 from "./exchange.vue?vue&type=style&index=0&id=567b100b&prod&scoped=true&lang=css"
import style1 from "./exchange.vue?vue&type=style&index=1&id=567b100b&prod&lang=scss&scoped=true"
import style2 from "./exchange.vue?vue&type=style&index=2&id=567b100b&prod&scoped=true&lang=css"
import style3 from "./exchange.vue?vue&type=style&index=3&id=567b100b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567b100b",
  null
  
)

export default component.exports